import { markNotificationAsRead } from '../utils.js';

export const handleLikeNotificationClick = async (notification, navigate) => {
  try {
    // Mark as read
    await markNotificationAsRead(notification.id);

    // Navigate to the post
    if (notification.postId) {
      const navigationState = { scrollToPost: notification.postId };

      // For comment/reply likes, focus the parent comment
      if (notification.commentId) {
        navigationState.focusComment = notification.commentId;
      }

      navigate('/home', { state: navigationState });
    } else if (notification.actionUrl) {
      navigate(notification.actionUrl);
    } else {
      navigate('/home');
    }

    return { success: true };
  } catch (error) {
    console.error('Error handling like notification:', error);
    return { success: false, error };
  }
};

export const handleCommentNotificationClick = async (notification, navigate) => {
  try {
    // Mark as read
    await markNotificationAsRead(notification.id);

    // Navigate to the post with comment focus
    if (notification.postId) {
      navigate('/home', {
        state: {
          scrollToPost: notification.postId,
          focusComment: notification.commentId
        }
      });
    } else if (notification.actionUrl) {
      navigate(notification.actionUrl);
    } else {
      navigate('/home');
    }

    return { success: true };
  } catch (error) {
    console.error('Error handling comment notification:', error);
    return { success: false, error };
  }
};

export const handleSolutionVoteClick = async (notification, navigate) => {
  try {
    // Mark as read
    await markNotificationAsRead(notification.id);

    // Navigate to the solution
    if (notification.solutionId) {
      navigate(`/solutions/${notification.solutionId}`);
    } else if (notification.actionUrl) {
      navigate(notification.actionUrl);
    } else {
      // Fallback to home since /solutions route doesn't exist
      navigate('/home');
    }

    return { success: true };
  } catch (error) {
    console.error('Error handling solution vote notification:', error);
    return { success: false, error };
  }
};
